module.exports = __webpack_public_path__ + "static/media/map-point-shared.7294b140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-point-shared.png
// module id = 340
// module chunks = 0